




























import { previewFile } from '@/utils';
import { Nullable } from '@homeserve/od-typings/utils';
import { Component, Emit, Model, Prop, Vue } from 'vue-property-decorator';

@Component
export default class FileField extends Vue {
  @Model('change', { type: File })
  public readonly file!: Nullable<File>;

  @Prop({ type: String, default: '*' })
  private accept!: string;

  @Emit('change')
  public clearFile(): null {
    return null;
  }

  public handlePreviewFile(file: File) {
    previewFile(file);
  }

  public openFileExplorer() {
    (this.$refs.fileInput as HTMLInputElement).click();
  }

  public selectFile(file: Nullable<File>) {
    if (!file) {
      return;
    }

    this.$emit('change', file);
  }
}
